import styled from "styled-components";
import theme from "../../styles/theme";
import Status from "../../types/enum/Status";
import Button from "../../components/Button";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import { ClickableIcon } from "../../components/Icon";
import Modal from "../../components/Modal";
import { Icon } from "@mui/material";
import { EvaluateTable } from "./EvaluteTable";
import { useEffect, useState } from "react";
import axios from "axios";
import SnackBar from "../../components/SnackBar";

type EvaluationModalProps = {
  isOpen?: boolean;
  setOpen: (x: boolean) => void;
  confirmFunction: () => void;
  title: string;
  evaluationData: any;
  studentId: string;
  semester: any;
  fetchCompetencyEvaluation: any;
  message: string;
  setMessage: any;
  isSnackbarOpen: boolean;
  setIsSnackbarOpen: any;
  messageType: any;
  setMessageType: any;
  messageHeader: string;
  setMessageHeader: any;
};
const Title = styled.div`
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  display: flex;
`;

const EvaluateModal = ({
  isOpen,
  setOpen,
  // confirmFunction,
  title,
  evaluationData,
  studentId,
  semester,
  fetchCompetencyEvaluation,
  message,
  setMessage,
  isSnackbarOpen,
  setIsSnackbarOpen,
  messageType,
  setMessageType,
  messageHeader,
  setMessageHeader,
}: EvaluationModalProps): JSX.Element => {
  useEffect(() => {
    setRatingData(evaluationData?.ratings);
    fetchActionTypes();
  }, [evaluationData]);
  const [ratingData, setRatingData] = useState(evaluationData?.ratings);
  const [stateChanged, setStateChanged] = useState(false);
  const [actionTypes, setActionTypes] = useState<any[]>([]);

  const fetchActionTypes = () => {
    axios
      .get("/student/evaluation/improvement-action-types")
      .then((res) => {
        const tempData = res.data.improvement_action_type?.map((item: any) => ({
          label: item.title,
          value: item.id,
        }));
        setActionTypes(tempData);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const confirmFunction = () => {
    const body = {
      student_id: studentId,
      semester_id: semester.id,
      ratings: ratingData,
    };
    axios
      .post("/student/competencyevaluation/save", body)
      .then((res) => {
        fetchCompetencyEvaluation();
        setIsSnackbarOpen(true);
        setMessageHeader("Success!");
        setMessage("Saved the Evaluation Form Successfully!");
        setMessageType("success");
        setStateChanged(false);
        setOpen(false);
      })
      .catch((err: any) => {
        setIsSnackbarOpen(true);
        setMessageType("error");
        setMessageHeader("Error!");
        if (err?.response?.data?.error) {
          setMessage(err.response.data?.error);
        } else {
          setMessage("Something Went Wrong in Saving the Evaluation Form!");
        }
      });
  };
  const handleClose = () => {
    setOpen(false);
    setStateChanged(false);
    setRatingData(evaluationData?.ratings);
  };
  return (
    <>
      <Modal
        onDismiss={() => handleClose()}
        isOpen={isOpen || false}
        setOpen={setOpen}
        customStyle={{
          overlay: { zIndex: "99900" },
          content: {
            marginTop: 20,
            maxWidth: "100vw",
            padding: "0 16px 24px 16px",
            background: "#090d20",
            boxShadow: "0 0 14px black",
          },
        }}
      >
        {/* <FlexBox
          style={{ height: "64px", borderBottom: "1px solid #80808026" }}
        >
          <FlexGrow>
            <Title>
              {" "}
              <Icon
                sx={{
                  // color: "#ffff86",
                  mr: 1,
                  textShadow: "0 1px 5px black",
                }}
              >
                assignment_turned_in
              </Icon>
              {title}
            </Title>
          </FlexGrow>
          <ClickableIcon name="times" onClick={() => handleClose()} />
        </FlexBox> */}
        <FlexBox justify="space-between" style={{ padding: "10px 0px" }}>
          <FlexBox style={{ fontSize: 14 }}>
            Please rate your competencies (
            <Icon
              sx={{
                color: "#faaf00",
                //   mr: 1,
                textShadow: "0 1px 5px black",
              }}
            >
              star
            </Icon>
            ) on a scale of 1 (Poor) to 5 (Excellent).{" "}
          </FlexBox>
          <FlexBox>
            <Button
              style={{
                width: "151px",
                height: "38px",
                padding: "13px 12px",
              }}
              isOutline
              onClick={() => {
                setOpen(false);
                setStateChanged(false);
                setRatingData(evaluationData?.ratings);
              }}
              status={Status.default}
            >
              Cancel
            </Button>

            <Button
              disabled={!stateChanged}
              style={{
                width: "151px",
                height: "38px",
                padding: "13px 12px",
              }}
              status={Status.button}
              onClick={() => {
                confirmFunction();
              }}
            >
              Save
            </Button>
          </FlexBox>
        </FlexBox>
        <EvaluateTable
          actionTypes={actionTypes}
          setStateChanged={setStateChanged}
          ratingData={ratingData}
          setRatingData={setRatingData}
          evaluationData={evaluationData}
        />
      </Modal>
    </>
  );
};

export default EvaluateModal;
